import {closeModal, openModal, polishPlurals, url} from "../../utilities";
import moment from "moment";
import {tokenInput} from "../../forms";
import axios from "axios";
import {Fancybox} from "../../jquery.fancybox";
import {toastAlert} from "../../toastAlert";

export const records_page = () => {
    const STATUS_INCOMING = 1;
    const STATUS_CANCELED = 2;
    const STATUS_ACTIVE = 3;
    const STATUS_FINISHED = 4;
    const STATUS_ANIMALS = 5;

    const ICON_INDEX = 0;
    const NO_INDEX = 1;
    const HUNTER_INDEX = 2;
    const AUTHORIZATIONS_INDEX = 3;
    const SECTORS_INDEX = 4;
    const START_DATE_INDEX = 5;
    const START_SIGNATURE_INDEX = 6;
    const END_DATE_INDEX = 7;
    const END_SIGNATURE_INDEX = 8;
    const ACTIONS_INDEX = 9;

    let booksRecordList = $("#bookRecordsList");
    if (booksRecordList.length > 0) {
        $(window).resize(function () {
            // booksRecordList.DataTable().api().columns.adjust().responsive.recalc();
        })
    }
    booksRecordList.DataTable({
        deferRender: true,
        data: window._records,
        columnDefs: [
            {
                targets: ICON_INDEX,
                data: 'icon_url',
                render: (data) => {
                    return `<img alt="Ikona polowania" class="book-record-icon" src="${data}"/>`;
                }
            },
            {
                targets: NO_INDEX,
                data: 'no'
            },
            {
                targets: HUNTER_INDEX,
                data: extendedAuthorizations ? 'member' : 'owner'
            },
            {
                targets: AUTHORIZATIONS_INDEX,
                data: extendedAuthorizations ? 'authorizations' : 'allAuthorizations',
                render: (data) => {
                    return data.map(a => a.number).join(', ')
                }
            },
            {
                targets: SECTORS_INDEX,
                data: 'sectors',
                render: (data) => {
                    return data.map(a => a.name).join(', ')
                }
            },
            {
                targets: START_DATE_INDEX,
                data: 'start',
                render: (data) => {
                    return moment(data).formatPHP('d/m/Y H:i');
                }
            },
            {
                targets: START_SIGNATURE_INDEX,
                data: 'author'
            },
            {
                targets: END_DATE_INDEX,
                data: 'end',
                render: (data) => {
                    if (!data) {
                        return '-';
                    }

                    return moment(data).formatPHP('d/m/Y H:i');
                }
            },
            {
                targets: END_SIGNATURE_INDEX,
                data: 'finisher'
            },
            {
                targets: ACTIONS_INDEX,
                data: null,
                render: (data, type, row) => {
                    let buttons = [];

                    if ((row.status === STATUS_FINISHED || row.status === STATUS_ANIMALS) && row.canEffectivenessBeVisible) {
                            buttons = [...buttons,
                                `
                                <button data-id="${row.id}"
                                        class="btn btn-primary btn-sm me-1 mb-1 btnDetails" type="button">
                                    <i class="fas fa-search"></i>
                                </button>
                            `
                            ]
                    }

                    if (!window._is_archival_season || window._isBookManagementRole) {
                        if (row.canBeCancelled) {
                            buttons = [...buttons,
                                `
                                    <form class="d-inline-block" data-confirm_color="secondary"
                                          data-confirm="Czy na pewno chcesz anulować te polowanie?" method="post"
                                          action="${url(`app/book/${row.id}/cancel`)}">
                                      ${tokenInput()}
                                        <button class="btn btn-sm btn-secondary me-1 mb-1 text-nowrap">
                                            <i class="fas fa-ban me-2"></i>
                                            Odwołaj
                                        </button>
                                    </form>
                                `
                            ]
                        }

                        if(row.canBeEnded) {
                            buttons = [...buttons,
                                `
                                    <a href="${url(`app/book/${row.id}/end`)}"
                                       class="btn btn-sm btn-danger me-1 mb-1 text-nowrap">
                                        <i class="fas fa-times me-2"></i>
                                        Zakończ
                                    </a>
                                `
                            ]
                        }

                        if(row.canBeUpdated) {
                            buttons = [...buttons,
                                `
                                    <a href="${url(`app/book/${row.id}/end`)}"
                                       class="btn btn-sm btn-primary me-1 mb-1 text-nowrap">
                                        <i class="fas fa-pen"></i>
                                    </a>
                                `
                            ]
                        }
                    }

                    if(row.status === STATUS_ANIMALS)
                    {
                        if(row.canModifyAttachments) {
                            if(row.hasAttachments){
                                buttons = [...buttons,
                                    `
                                <a class="btn btn-primary btn-sm me-1 mb-1 text-white" href="${url(`app/book/${row.id}/attachments`)}"><i class="fas fa-camera"></i></a>
                            `
                                ]
                            }else {
                                buttons = [...buttons,
                                    `
                                <a class="btn btn-secondary btn-sm me-1 mb-1 text-white" href="${url(`app/book/${row.id}/attachments`)}"><i class="fas fa-camera"></i></a>
                            `
                                ]
                            }
                        }else{
                            if(row.hasPublicAttachments) {
                                buttons = [...buttons,
                                    `
                                <button class="btn btn-primary btn-sm me-1 mb-1 text-white btnAnimalsAttachments" type="button" data-id="${row.id}"><i class="fas fa-camera"></i></button>
                            `
                                ]
                            }
                        }
                    }


                    return `<span class="text-nowrap">${buttons.join('')}</span>`
                }
            }
        ],
        rowCallback: function(row, data) {
            if(data.status === STATUS_ANIMALS) {
                $(row).addClass('book-record-animals')
            }

            switch(data.status) {
                case STATUS_FINISHED:
                    $(row).addClass('book-record-ended')
                    break;
                case STATUS_ACTIVE:
                    $(row).addClass('book-record-active')
                    break;
                case STATUS_INCOMING:
                    $(row).addClass('book-record-incoming')
                    break;
                case STATUS_CANCELED:
                    $(row).addClass('book-record-cancelled')
                    break;
            }
        },
        filters: {
            columns: [
                {
                    index: 1,
                    title: 'Polowania',
                    values: [
                        {
                            text: 'tylko skuteczne',
                            value: 'tylko skuteczne',
                            custom: (settings, searchData, index, rowData) => {
                                return rowData.status === STATUS_ANIMALS;
                            }
                        }
                    ]
                },
                {
                    index: 1,
                    title: 'Myśliwi',
                    placeholder: 'wszyscy',
                    values: [
                        {
                            text: 'tylko ja',
                            value: 'tylko ja',

                            custom: (settings, data) => {
                                data = data[2];

                                let name = $('#dropdown__user').find('.name').html();
                                return data === name;
                            }
                        }
                    ]

                }
            ]
        },
        responsive: {
            details: {
                renderer: function (api, rowIdx, columns) {
                    if (!columns) {
                        return false;
                    }

                    let shouldCollapse = window.innerWidth < 768;
                    let container = $(`<div class="row pb-3 record-child-container ${!shouldCollapse ? 'g-3' : ''}" />`);

                    let status = api.row(rowIdx).data().status;

                    let active = status === STATUS_ACTIVE;
                    let incoming = status === STATUS_INCOMING;
                    let cancelled = status === STATUS_CANCELED;
                    let ended = status === STATUS_FINISHED || status === STATUS_ANIMALS;
                    let animals = status === STATUS_ANIMALS;

                    let header = $('');

                    if (active) {
                        container.addClass('book-record-active');
                        container.css('outline-color', '#af1618');
                        header = $(`
                            <div class="mt-0 col-12 py-2 text-center border-danger" style="border-bottom: 1px solid">
                                <span class="d-block">
                                    <img alt="Ikona aktywnego polowania" class="book-record-icon me-1" src="${url('images/book-record-active.png')}" />
                                    Polowanie trwa
                                </span>
                            </div>
                        `)
                    } else if (cancelled) {
                        container.addClass('book-record-cancelled');
                        header = $(`
                            <div class="mt-0 col-12 py-2 text-center border-secondary" style="border-bottom: 1px solid">
                                <span class="d-block">
                                    <img alt="Ikona anulowanego polowania" class="book-record-icon me-1" src="${url('images/book-record-cancelled.png')}" />
                                    Polowanie anulowane
                                </span>
                            </div>
                        `)
                        container.css('outline-color', 'gray');
                    } else if (incoming) {
                        container.addClass('book-record-incoming');
                        header = $(`
                            <div class="mt-0 col-12 py-2 text-center border-secondary" style="border-bottom: 1px solid">
                                <span class="d-block">
                                    <img alt="Ikona nadchodzącego polowania" class="book-record-icon me-1" src="${url('images/book-record-active.png')}" />
                                    Polowanie nadchodzące
                                </span>
                            </div>
                        `)
                        container.css('outline-color', 'gray');
                    } else if (ended) {
                        container.addClass('book-record-ended');
                        if (animals) {
                            container.addClass('book-record-animals');
                            header = $(`
                                <div class="mt-0 col-12 py-2 text-center border-primary" style="border-bottom: 1px solid">
                                    <span class="d-block">
                                        <img alt="Ikona polowania z upolowaną zwierzyną" class="book-record-icon me-1" src="${url('images/book-record-animals.png')}" />
                                        Polowanie zakończone
                                    </span>
                                </div>
                            `)
                        } else {
                            header = $(`
                                <div class="mt-0 col-12 py-2 text-center border-primary" style="border-bottom: 1px solid">
                                    <span class="d-block">
                                        <img alt="Ikona zakończonego polowania" class="book-record-icon me-1" src="${url('images/book-record-finished.png')}" />
                                        Polowanie zakończone
                                    </span>
                                </div>
                            `)
                        }
                    }

                    if (!shouldCollapse) {
                        let table = $('<table class="records-list-child-table" />')
                        for (let column of columns) {
                            if (!column.hidden) {
                                continue;
                            }

                            let row = $('<tr />');
                            row.append(`<td class="fw-bold">${column.title}</td>`)
                            row.append(`<td>${column.data}</td>`)

                            table.append(row)
                        }

                        container.append(table);

                        return container;
                    }

                    container.append(header);

                    let i = -1;
                    for (let column of columns) {
                        if (!column.hidden && !shouldCollapse) {
                            continue;
                        }

                        if (shouldCollapse && column.columnIndex === 0) {
                            continue;
                        }

                        if (shouldCollapse && (column.columnIndex === START_SIGNATURE_INDEX || column.columnIndex === END_SIGNATURE_INDEX)) {
                            continue;
                        }

                        if (column.columnIndex === START_DATE_INDEX || column.columnIndex === END_DATE_INDEX) {
                            let user = '';

                            if (column.data !== '-') {
                                user = `<br /> ${columns[column.columnIndex + 1].data}`;
                            }

                            container.append(`
                                <div class="col-12 col-sm-6 mt-3">
                                    <div class="row">
                                        <div class="col-12 fw-bold ${i % 2 === 0 ? 'text-sm-end' : ''}">${column.title}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 ${i % 2 === 0 ? 'text-sm-end' : ''}">${column.data}${user}</div>
                                    </div>
                                </div>
                                `);
                        } else {
                            container.append(`
                                <div class="col-12 col-sm-6 mt-3">
                                    <div class="row">
                                        <div class="col-12 fw-bold ${i % 2 === 0 ? 'text-sm-end' : ''}">${column.title}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 ${i % 2 === 0 ? 'text-sm-end' : ''}">${column.data}</div>
                                    </div>
                                </div>
                            `);
                        }

                        i++;
                    }

                    return container;
                }
            }
        }
    });

    $("#pdfOptions_generate_cover").change(function () {
        if ($(this).prop('checked')) {
            $("#pdfOptions_fill_cover").closest('.col-12').show();
        } else {
            $("#pdfOptions_fill_cover").closest('.col-12').hide();
        }
    })

    /// Pokazanie szczegółowych informacji o polowaniu
    $('body').on('click', '.btnDetails', function () {
        let modal = $("#detailsModal");
        let record = window._records.find(r => parseInt(r.id) === parseInt($(this).data('id')))
        let role = window._role ?? 0;
        let is_book_management_role = window._isBookManagementRole ?? 0;
        let shots_fired = record.shots_fired ?? 0;
        let comments = record.comments;
        let animals = record.animals;
        $("#shots_fired").text(shots_fired + ' ' + polishPlurals('strzał', 'strzały', 'strzałów', shots_fired));
        $("#comments").text(comments ? comments : 'Brak');

        modal.find('tbody tr').remove();

        if (animals.length > 0) {
            modal.find('.animalsTable').show();
            modal.find('.modal-body h5').hide();
            for (let animal of animals) {
                let row = $('<tr />');
                if(role || is_book_management_role != "0"){
                    row.append(`
                    <td>${animal.animal}</td>
                    <td>${animal.intended_use}</td>
                    <td>${animal.collection_centre}</td>
                    <td>${animal.identifier}</td>
                    <td>${animal.weight}</td>
                    <td>${animal.quantity}</td>
                    ${extendedAuthorizations ? `<td>${animal.authorizations.join(', ')}</td>` : ''}
                    <td>${(animal.hunting_date && animal.hunting_date.length > 0) ? animal.hunting_date.map(date => moment(date).format("HH:mm")).join(', ') : '-'}</td>
                    `);
                }else {
                    row.append(`
                    <td>${animal.animal}</td>
                    <td>${animal.quantity}</td>
                    ${extendedAuthorizations ? `<td>${animal.authorizations.join(', ')}</td>` : ''}
                    <td>${(animal.hunting_date && animal.hunting_date.length > 0) ? animal.hunting_date.map(date => moment(date).format("HH:mm")).join(', ') : '-'}</td>
                `);
                }
                modal.find('tbody').append(row);
            }
        } else {
            modal.find('.animalsTable').hide();
            modal.find('.modal-body h5').show();
        }

        openModal(modal);
    })

    $('body').on('click', '.btnAnimalsAttachments', async function () {

        let id = $(this).data('id');
        let modal = $("#animalsAttachmentsModal");
        let tbody = modal.find('table tbody');
        tbody.empty();
        try{
            let response = await axios.get(url(`api/book/${id}/get-attachments`));
            let data = response.data;
            if(data){
                for(let animal of data.record.book_record_animals) {
                    if(animal.attachments) {
                        for(let attachment of animal.attachments) {
                            if (parseInt(attachment.is_hidden) === 0) {
                                let tr = (`
                        <tr style="vertical-align: middle">
                            <td>${animal.animal.display_name}
                            </td>
                            <td><img alt="Zdjęcie" src=${url(`app/book/${attachment.id}/${data.record.id}/get-attachment`)} 
                            style="
                                width: 300px; height: 200px; border-radius: 4px; border: 1px solid #000000; cursor:pointer;
                            "
                            class="btnAnimalAttachments"
                            data-fancybox="responsive"
                            data-caption="
                             <div style='text-align: center;'>
                             <strong style='font-size:20px;
                                text-justify: inter-word;'>${animal.animal.display_name}</strong> <br/>
                                <span>${attachment.comments ?? ''}</span>
                             <div>"/></td>
                        </tr>
                    `)
                                tbody.append(tr);
                            }
                        }
                    }
                }
            }
            Fancybox.bind("[data-fancybox]", {});
            openModal(modal);
        }catch (err){
            toastAlert('Wystąpił błąd podczas pobierania danych. Spróbuj ponownie później.', {type: 'danger'});
        }


    })

    $('body').on('click', '.btnAnimalAttachments', function () {
        let modal = $("#animalsAttachmentsModal");
        closeModal(modal);
    })

}
